import { ComponentsOverrides, Theme } from "@mui/material";

type MuiMenuOverrides = {
  styleOverrides: ComponentsOverrides<Theme>["MuiMenu"];
};

const MuiMenu: MuiMenuOverrides = {
  styleOverrides: {
    root: {
      ".MuiMenu-paper": {
        border: "1px solid #E8EFEF",
        boxShadow: "0px 2px 10px 0px #0000001A, 0px 1px 1px 0px #0000001F",
      },
    },
  },
};

export { MuiMenu };
